import { Box, Tooltip } from '@mui/material';

import { ActionIconButton } from '../../../common/components';
import { RETURN_STATUSES, RETURN_TEXTS as TEXTS } from '../constants/consumptionReturnTexts';

/**
 * Acciones de una devolución: ver siempre y anular solo si está pendiente y el usuario autoriza.
 * @param {Object} props
 * @param {Object} props.row Devolución.
 * @param {boolean} props.canCancel Si el usuario puede anular devoluciones.
 * @param {boolean} props.disabled Deshabilita las acciones mientras hay otra en curso.
 * @param {Function} props.onView Abre el drawer de la devolución.
 * @param {Function} props.onCancel Pide confirmación para anularla.
 * @returns {JSX.Element}
 */
const ConsumptionReturnActions = ({ row, canCancel, disabled, onView, onCancel }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <Tooltip title={TEXTS.view}>
      <span>
        <ActionIconButton
          variant="view"
          aria-label={TEXTS.view}
          disabled={disabled}
          onClick={() => onView(row)}
        />
      </span>
    </Tooltip>
    {canCancel && row.status === RETURN_STATUSES.PENDING && (
      <Tooltip title={TEXTS.cancelReturn}>
        <span>
          <ActionIconButton
            variant="close"
            aria-label={TEXTS.cancelReturn}
            disabled={disabled}
            onClick={() => onCancel(row)}
          />
        </span>
      </Tooltip>
    )}
  </Box>
);

export default ConsumptionReturnActions;
